<mdc-dialog>
  <mdc-dialog-container>
    <mdc-dialog-surface>
      <mdc-dialog-title>Fribillett</mdc-dialog-title>
      <mdc-dialog-content>
        <h3>Scann QR-kode</h3>
        <video #scanVideoElm></video>
        <h3>Eller skriv inn kode:</h3>
        <div class="fribillett__kode">
          <mdc-text-field outlined [formControl]="kodeinput" label="Fribillettkode (FRI-...)" (keydown.ENTER)="verifiser()"></mdc-text-field>
        </div>
        <div class="melding">
          <div class="invalid" *ngIf="feilmelding">{{ feilmelding }}</div>
          <div class="detaljer" *ngIf="detaljertFeil">{{ detaljertFeil }}</div>
          <div class="valid" *ngIf="validertKode">OK: Fribillett {{ fribillettNummer }}</div>
        </div>
        <app-spinner *ngIf="pending" [inline]="true"></app-spinner>
      </mdc-dialog-content>
      <mdc-dialog-actions>
        <button mdc-button class="button-no-bg" mdcDialogAction="close">Avbryt</button>
        <button mdc-button raised [disabled]="!validertKode" (click)="brukFribillett()">Bruk</button>
      </mdc-dialog-actions>
    </mdc-dialog-surface>
  </mdc-dialog-container>
</mdc-dialog>
